module.exports = __webpack_public_path__ + "img/230.b362b55f.jpg";